<template>
  <div>
    <popup-warp v-model="currentValue" backgroundColor="rgba(255, 255, 255, 0)">
      <div class="about-preauth-warp">
        <div class="about-preauth-block"></div>
        <div class="about-preauth-body">
          <img src="@/assets/imgs/icon_info.png" alt="">
          <div class="about-preauth-cont">
            <div class="about-preauth-title">{{ i18n.title }}</div>
            <div>{{ i18n.tips1 }}</div>
            <div class="about-preauth-tips">{{ i18n.tips2 }}</div>
            <div>{{ i18n.tips3 }}</div>
          </div>
        </div>
      </div>
    </popup-warp>
  </div>
</template>

<script>
import { PopupWarp } from "@/components/popup"
export default {
  props: {
    // 是否显示
    value: {
      type: Boolean,
      default: false
    }
  },
  components: {
    PopupWarp
  },
  computed: {
    currentValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit("input", val)
      }
    },
    i18n() {
      return this.$t("preauth")
    }
  }
}
</script>

<style lang="less">
.about-preauth-warp {
  border-radius: 100px 100px 0 0;
  background-color: #fff;
  padding: 32px 48px 200px;
  .about-preauth-block {
    width: 112px;
    height: 8px;
    border-radius: 4px;
    margin: 0 auto 40px;
    background-color: #EBEBEB;
  }
  .about-preauth-body {
    display: flex;
    img {
      width: 50px;
      height: 50px;
      display: block;
      margin-right: 22px;
    }
    .about-preauth-cont {
      flex: 1;
      color: #666666;
      font-size: 24px;
      .about-preauth-title {
        padding-bottom: 34px;
        color: #171917;
        font-size: 40px;
        font-weight: 600;
      }
      .about-preauth-tips {
        font-weight: 600;
        padding: 64px 0;
      }
    }
  }
}
</style>
